module.exports = {"id":"192086","name":"Alexandr Kokorin","rating":"80","photo":"./data/images/photos/3/192086.png","club":{"name":"Zénith","logo":"./data/images/clubs/Zenith.png"},"positions":["BU","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexandrKokorin0.json
// module id = 246
// module chunks = 0